// generated by genversion
export var version = '3.4.1';
//# sourceMappingURL=version.js.map